import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Kundengruppe } from '../entities/customers/kundengruppe.entity';
import { Kundensegment } from '../entities/customers/kundensegment.entity';
//#endregion

@Injectable()
export class KundengruppeService extends ODataEntityService<Kundengruppe> {
  constructor(protected client: ODataClient) {
    super(client, 'Kundengruppe', 'entities.customers.Kundengruppe');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public kundensegmente(entity: EntityKey<Kundengruppe>): ODataNavigationPropertyResource<Kundensegment> {
    return this.entity(entity).navigationProperty<Kundensegment>('kundensegmente');
  }
  //#endregion
}
